import Swiper, { Navigation, Pagination, Lazy } from 'swiper';
import $ from 'jquery';
const ITEM = '.LandingpageCarousel-navItem';
const SLIDE = '.LandingpageCarousel-slide';
export const init = async function() {
    // configure Swiper to use modules
    Swiper.use([
        Navigation,
        Pagination,
        Lazy
    ]);
    // settings
    const settings = {
        pagination: {
            el: '.swiper-pagination',
            type: 'progressbar'
        },
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev'
        },
        // Enable lazy loading
        lazy: {
            loadPrevNext: true
        },
        slidesPerView: 'auto',
        centeredSlides: false,
        loop: false,
        spaceBetween: 20,
        breakpoints: {
            1024: {
                slidesPerView: 'auto',
                spaceBetween: 27
            }
        }
    };
    // init carousel
    let mySwiper = new Swiper('.js-landingpage-carousel', settings);
    // hide all slides
    $(SLIDE).hide();
    $(SLIDE).removeClass('swiper-slide');
    // reinit carousel on category change
    $(ITEM).on('click', function() {
        mySwiper.destroy();
        $(ITEM).removeClass('active');
        $(this).addClass('active');
        const collection = $(this).attr('collection-name');
        $(SLIDE).hide();
        $('.LandingpageCarousel-slide[data-collection="' + collection + '"]').show();
        $('.LandingpageCarousel-slide[data-collection="' + collection + '"]').addClass('swiper-slide');
        mySwiper = new Swiper('.js-landingpage-carousel', settings);
    });
    // trigger click on first category
    $(ITEM).first().trigger('click');
    //KEYBOARD USERS
    $(ITEM).on('keyup', function(e) {
        if (e.keyCode === 13) {
            mySwiper.destroy();
            $(ITEM).removeClass('active');
            $(this).addClass('active');
            const collection = $(this).attr('collection-name');
            $(SLIDE).hide();
            $('.LandingpageCarousel-slide[data-collection="' + collection + '"]').show();
            $('.LandingpageCarousel-slide[data-collection="' + collection + '"]').addClass('swiper-slide');
            mySwiper = new Swiper('.js-landingpage-carousel', settings);
        }
    });
};
